import React, { Fragment, useEffect, useState } from 'react';
import { Col, Button } from "reactstrap";
import { SelectForm } from "../../Basicos/index";
import { axiosApi } from '../../Basicos/axiosInstances';

const FiltrosRodizio = ({ novoOnClick, filtros, dados, setDadosFiltrados, valoresFiltro, setValoresFiltro }) => {
    const { periodos_letivos, semestres, turmas } = filtros

    const [ciclosOptions, setCiclosOptions] = useState([]);
    const [servicosOptions, setServicosOptions] = useState([]);
    const [turmasOptions, setTurmasOptions] = useState([]);

    const periodosOptions = periodos_letivos && periodos_letivos.map(p => ({ value: p.id, label: p.descricao }))
    const semestresOptions = semestres && semestres.map(s => ({ value: s.id, label: s.descricao }))

    const style = {
        col: { xs: 12, md: 2, sm: 2, lg: 2, xl: 2 }
    }

    useEffect(() => {
        if (valoresFiltro.periodo_letivo_id && valoresFiltro.semestre_id) {
            getTurmas(valoresFiltro.periodo_letivo_id, valoresFiltro.semestre_id);
        } else {
            setTurmasOptions([]);
        }
    }, [valoresFiltro.periodo_letivo_id, valoresFiltro.semestre_id]);

    const getTurmas = async (periodoId, semestreId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/filtro-turmas-semestre?periodo_letivo_id=${periodoId}&semestre_id=${semestreId}`);
            setTurmasOptions(data.map(element => ({ label: element.descricao, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (valoresFiltro.semestre_id && valoresFiltro.turma_id) {
            getCiclos(valoresFiltro.semestre_id, valoresFiltro.turma_id);
        } else {
            setCiclosOptions([]);
            setServicosOptions([]);
        }
    }, [valoresFiltro.semestre_id, valoresFiltro.turma_id]);

    useEffect(() => {
        if (valoresFiltro.ciclo_id) {
            getServicos(valoresFiltro.ciclo_id);
        } else {
            setServicosOptions([]);
        }
    }, [valoresFiltro.ciclo_id]);

    const getCiclos = async (semestreId, turmaId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/ciclos-semestre?semestre_id=${semestreId}&turma_id=${turmaId}`);
            setCiclosOptions(data.map(element => ({ label: element.titulo, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    }

    const getServicos = async (cicloId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/servicos-ciclo?ciclo_id=${cicloId}`);
            setServicosOptions(data.map(element => ({ label: element.descricao, value: element.id })));
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeSelect = (nome, valor) => {
        let novosValores = { ...valoresFiltro, [nome]: valor };

        // Limpa filtros dependentes
        if (nome === 'periodo_letivo_id' || nome === 'semestre_id') {
            novosValores.turma_id = undefined;
            novosValores.ciclo_id = undefined;
            novosValores.servico_id = undefined;
            novosValores.servico_label = undefined;
        } else if (nome === 'turma_id') {
            novosValores.ciclo_id = undefined;
            novosValores.servico_id = undefined;
            novosValores.servico_label = undefined;
        } else if (nome === 'ciclo_id') {
            novosValores.servico_id = undefined;
            novosValores.servico_label = undefined;
        }

        if (nome === 'servico_id') {
            novosValores.servico_label = servicosOptions.find(opt => opt.value === valor)?.label;
        }

        setValoresFiltro(novosValores);

        let dadosFiltrados = dados;

        if (novosValores.periodo_letivo_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.periodo_letivo_id === novosValores.periodo_letivo_id);
        }
        if (novosValores.semestre_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.semestre_id === novosValores.semestre_id);
        }
        if (novosValores.turma_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.turma_id === novosValores.turma_id);
        }
        if (novosValores.ciclo_id) {
            dadosFiltrados = dadosFiltrados.filter(d => d.ciclo_id === novosValores.ciclo_id);
        }
        if (novosValores.servico_id) {
            const servicoLabel = servicosOptions.find(opt => opt.value === novosValores.servico_id)?.label;
            if (servicoLabel) {
                dadosFiltrados = dadosFiltrados.filter(d => d.servico?.descricao === servicoLabel);
            }
        }

        setDadosFiltrados(dadosFiltrados);
    }

    return (
        <Fragment>
            <SelectForm
                label="Período Letivo"
                name="periodo_letivo_id"
                placeholder="Período"
                options={periodosOptions}
                onChange={onChangeSelect}
                value={periodosOptions && periodosOptions.find(option => (option.value === valoresFiltro.periodo_letivo_id)) || ''}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Semestre"
                name="semestre_id"
                placeholder="Semestre"
                options={semestresOptions}
                value={semestresOptions && semestresOptions.find(option => (option.value === valoresFiltro.semestre_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Turma"
                name="turma_id"
                placeholder="Turma"
                options={turmasOptions}
                value={turmasOptions && turmasOptions.find(option => (option.value === valoresFiltro.turma_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Ciclo"
                name="ciclo_id"
                placeholder="Ciclo"
                options={ciclosOptions}
                value={ciclosOptions && ciclosOptions.find(option => (option.value === valoresFiltro.ciclo_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            <SelectForm
                label="Serviço"
                name="servico_id"
                placeholder="Serviço"
                options={servicosOptions}
                value={servicosOptions && servicosOptions.find(option => (option.value === valoresFiltro.servico_id)) || ''}
                onChange={onChangeSelect}
                style={{ col: style.col }}
                menuPortalTarget={document.body}
            />
            
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2"
                    onClick={() => {
                        setValoresFiltro({
                            periodo_letivo_id: undefined,
                            semestre_id: undefined,
                            turma_id: undefined,
                            ciclo_id: undefined,
                            servico_id: undefined,
                            servico_label: undefined
                        });
                        setDadosFiltrados(dados);
                    }}>Limpar</Button>
            </Col>
            <Col className="btn-limpar-filtro" md={1} sm={1} lg={1} xl={1}>
                <Button className="mx-3 py-2" onClick={novoOnClick}>Novo</Button>
            </Col>
        </Fragment >)
}

export default FiltrosRodizio;
